'use strict';

var mortgageRates_constants = require('./mortgageRates.constants-43194cde.js');
var Typography = require('./Typography-d8cec00c.js');
var jsxRuntime = require('react/jsx-runtime');

/* eslint-disable max-len */
var staticContent = {
  heading: /*#__PURE__*/jsxRuntime.jsxs("div", {
    children: [/*#__PURE__*/jsxRuntime.jsx(Typography.Typography, {
      variant: "h2",
      children: "Compare our current interest rates"
    }), /*#__PURE__*/jsxRuntime.jsx(Typography.Typography, {
      variant: "bodyM",
      children: "See your personalized rates by providing answers to a few questions below. You might even qualify for lower rates based on the information you provide. Click on Mortgage rates disclaimers below to see assumptions."
    })]
  }),
  errorContent: 'We apologize. Current market volatility has disabled our ability to show rates. To explore your personal rate please answer just a few questions. No obligation or impact on credit score.',
  errorCtaText: 'Explore personal rate',
  errorCtaUrl: 'https://apply.rate.com/apply',
  tableHeadings: ['Loan Type', 'Rate', 'APR', 'Points', 'Mo. Payment'],
  // rateInfoHelper: 'Interest rate is based upon <loanAmount> in <userLocation>, CA with a <downPayment> down payment, <creditScore> credit score for a primary use single family home with <points> points.',
  paymentHelper: 'Monthly payments include mortgage principal and interest (P&I) payments only.',
  pointsHelper: '1 point is equal to 1% of the loan amount.',
  loanAmount: 400000,
  submitModal: {
    paragraph: 'Rates are changing quickly. Lock in your rate faster by answering a few more questions.',
    disclaimerPrimary: 'This is not a loan commitment. Your actual rates and costs could be higher. Get an Official Loan Estimate before selecting a loan.',
    redirectUrl: 'https://apply.rate.com',
    closeModalText: 'Keep shopping',
    redirectText: 'Continue'
  },
  rateTableFormSubmitModal: {
    paragraph: 'Lock in your rate faster by chatting with a loan expert.',
    disclaimerPrimary: 'This is not a loan commitment. Your actual rates and costs could be lower or higher. Get an official loan estimate before selecting a loan.',
    primaryButtonText: 'Apply now',
    secondaryButtonText: 'Refine my search',
    closeModalText: 'Keep shopping',
    disclaimerSecondary: 'Mortgage rates and loan options displayed depend on a number of variables, including the accuracy of the information you have entered, which is subject to verification, credit and property approval.',
    vpInfoHeader: 'Your mortgage know-it-all'
  },
  loModal: {
    text: 'Are you working with a loan officer from Rate?',
    yesCta: 'Yes',
    noCta: 'No'
  },
  formSteps: [{
    heading: 'Get your personalized rates!',
    subHeading: 'Tell us your situation and we can give you low accurate rates.'
  }, {
    heading: 'How can we contact you?',
    subHeading: 'Your information will be safe and kept confidential.'
  }]
};
var dynamicLoanProductRatesHeading = function dynamicLoanProductRatesHeading(ratesHeadingTitle, defaultLoanProductsType) {
  var ratesParaTitle = ratesHeadingTitle;
  if (defaultLoanProductsType === mortgageRates_constants.LoanTypeValues.FHA || defaultLoanProductsType === mortgageRates_constants.LoanTypeValues.VA) {
    ratesParaTitle = ratesHeadingTitle.split(' ')[0];
  }
  return /*#__PURE__*/jsxRuntime.jsxs("div", {
    children: [/*#__PURE__*/jsxRuntime.jsxs(Typography.Typography, {
      variant: "h2",
      children: ["Today\u2019s current ", ratesHeadingTitle, " mortgage rates*"]
    }), /*#__PURE__*/jsxRuntime.jsxs(Typography.Typography, {
      variant: "bodyM",
      children: ["See your personalized rates for a ", ratesParaTitle, " mortgage by providing answers to a few questions below. You may even qualify for a lower rate based on the information you provide. Click into mortgage rate disclaimers to see assumptions and details."]
    })]
  });
};

exports.dynamicLoanProductRatesHeading = dynamicLoanProductRatesHeading;
exports.staticContent = staticContent;
